const LOCAL_STORAGE_COMPARE_KEY = 'shopify-compare';
const LOCAL_STORAGE_COMPARE_DELIMITER = ',';
const BUTTON_COMPARE_ACTIVE_CLASS = 'active';
const GRID_COMPARE_LOADED_CLASS = 'loaded';

const selector = {
  button: '[button-compare]',
  grid: '[grid-compare]',
  gridempty :'[ProductGridContainer]',
  productCard: '.grid__item',
  removebtn : '[button-compare-remove]'
};
// console.log(selector);

document.addEventListener('DOMContentLoaded', () => {
  initCompareButtons();
  initCompareGrid();
});

document.addEventListener('shopify-compare:updated', (event) => {
  console.log('[Shopify Compare] Compare Updated ✅', event.detail.compare);
  var compare_length = $('.kg-compare-count').text(event.detail.compare.length);
  initCompareGrid();
});

document.addEventListener('shopify-compare:init-product-grid', (event) => {
  console.log('[Shopify Compare] Compare Product List Loaded ✅', event.detail.compare);

  document.querySelectorAll('.removeproduct').forEach(el =>
    
    el.addEventListener('click', function(event) {
    var current_value=this.getAttribute('data-product-handle').toLowerCase();
   
    const compare = localStorage.getItem('shopify-compare');
    if (compare)  
    {
      const compare_array=compare.split(LOCAL_STORAGE_COMPARE_DELIMITER);
        compare_arrays = compare_array.filter(function(item) {
          return item.toLowerCase() !== current_value
        })
      
      localStorage.setItem('shopify-compare', compare_arrays);
    
    }
    location.reload();
  }));
  
//   var compare_length = $('.kg-compare-count').text(event.detail.compare.length);
});

document.addEventListener('shopify-compare:init-compare-buttons', (event) => {
  console.log('[Shopify Compare] Compare Buttons Loaded ✅', event.detail.compare);
  var compare_length = $('.kg-compare-count').text(event.detail.compare.length);
});



const ComparefetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card-compare`;
//   console.log(productTileTemplateUrl);
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
//     console.log(res);
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
//    console.log(htmlDocument);
    const productCard = htmlDocument.documentElement.querySelector(selector.productCard);
   
   
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Compare] Failed to load content for handle: ${handle}`, err));
};


const comparesetupGrid = async (grid) => {
  const compare = getCompare();
    
  const requests = compare.map(ComparefetchProductCardHTML);
//   console.log(requests);
  const responses = await Promise.all(requests);
  const compareProductCards = responses.join('');
  const static_html='<td><ul class="kg-right"><li class="img"></li><li><div class="label">Price</div></li><li><div class="label">Model</div></li><li><div class="label">Add To Cart</div></li><li><div class="label">capacity</div></li><li><div class="label">temperature range</div></li><li><div class="label">ambient temperature</div></li><li><div class="label">input power</div></li><li><div class="label">voltage</div></li><li><div class="label">frequency</div></li><li><div class="label">current</div></li><li><div class="label">energy consumption</div></li><li><div class="label">refrigerant</div></li><li><div class="label">product dimension mm</div></li><li><div class="label">package dimension mm</div></li><li><div class="label">internal dimension mm</div></li><li><div class="label">product weight</div></li><li><div class="label">shipping weight</div></li><li><div class="label">warranty</div></li><li><div class="label">back in stock date</div></li><li><div class="label">gastype</div></li><li><div class="label">number of burners</div></li><li><div class="label">burner configuration</div></li><li><div class="label">temperature range burners</div></li><li><div class="label">temperature range oven</div></li><li><div class="label">internal oven dimension</div></li><li><div class="label">gas consumption (MJ/h)</div></li><li><div class="label">dough capacity</div></li><li><div class="label">mixing speed</div></li></ul></td>';
  if(compareProductCards)
  {
     grid.innerHTML = static_html+compareProductCards;
  }else
  {
     document.querySelector('#ProductGridContainer').innerHTML ='<p class="compare_page_empty_items">No items Found!</p>';
  }
  grid.classList.add(GRID_COMPARE_LOADED_CLASS);
  initCompareButtons();

  const event = new CustomEvent('shopify-compare:init-product-grid', {
    detail: { compare: compare }
  });
  document.dispatchEvent(event);
};

const setupCompareButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Compare] Missing `data-product-handle` attribute. Failed to update the compare.');
    if (compareContains(productHandle)) button.classList.add(BUTTON_COMPARE_ACTIVE_CLASS);
    button.addEventListener('click', () => {
      updateCompare(productHandle);
      button.classList.toggle(BUTTON_COMPARE_ACTIVE_CLASS);
    });
  });
};

const initCompareGrid = () => {
  const grid = document.querySelector(selector.grid) || false;
   
  if (grid) comparesetupGrid(grid);
};

const initCompareButtons = () => {
  const buttons = document.querySelectorAll(selector.button) || [];
//   console.log(buttons);
  if (buttons.length) setupCompareButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-compare:init-compare-buttons', {
    detail: { compare: getCompare() }
  });
  document.dispatchEvent(event);
};

const getCompare = () => {
  const compare = localStorage.getItem(LOCAL_STORAGE_COMPARE_KEY) || false;
  if (compare) return compare.split(LOCAL_STORAGE_COMPARE_DELIMITER);
  return [];
};

const setCompare = (array) => {
  const compare = array.join(LOCAL_STORAGE_COMPARE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_COMPARE_KEY, compare);
  else localStorage.removeItem(LOCAL_STORAGE_COMPARE_KEY);

  const event = new CustomEvent('shopify-compare:updated', {
    detail: { compare: array }
  });
  document.dispatchEvent(event);
  return compare;
};

const updateCompare = (handle) => {
  const compare = getCompare();
  const indexInCompare = compare.indexOf(handle);
  if (indexInCompare === -1) compare.push(handle);
  else compare.splice(indexInCompare, 1);
  return setCompare(compare);
};

const compareContains = (handle) => {
  const compare = getCompare();
  return compare.includes(handle);
};

const resetCompare = () => {
  return setCompare([]);
};